import '../../resources/css/layout/SiteLayout.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {WAIT_LOGIN, reLoginBySession, doLogout} from '../../actions/login/index';
import MainHeader from '../../components/frame/MainHeader';
import SitePage from '../site/SitePage';
import ModalAccountConfig from '../../components/login/ModalAccountConfig';
import Loading from '../../components/common/Loading';
import ModalAccountForm from '../../components/login/ModalAccountForm';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalTip from '../../components/common/ModalTip';
import ModalAlert from '../../components/common/ModalAlert';
import ModalLoading from '../../components/common/ModalLoading';
import {doActivePage} from "../../actions/menu";

class SiteLayout extends Component {

    constructor(props) {
        super(props);
        const { activePage, doActivePage } = this.props;
        if (activePage !== 'site') {
            doActivePage('site');
        }
    }

  isNeedReLogin = ( loginStatus ) => {
    const { doLogout, history, authToken } = this.props;

    if (loginStatus === WAIT_LOGIN || !authToken) {
      const loginParams = window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN);

      if (loginParams) {
        return true;
      } else {
        doLogout();
        history.push(window.CONFIG.WEB_ROOT + '/Login');
      }
    }

    return false;
  }

  componentDidMount() {

    const { loginStatus, reLoginBySession } = this.props;

    if (this.isNeedReLogin(loginStatus)) {
      this.isReloadPage = true;
      reLoginBySession();
    }
  }

  render() {
    const { loginStatus } = this.props;
    // do auto re-login by session
    if (this.isNeedReLogin(loginStatus)) {
      return (
        <Loading loading={true}></Loading>
      )
    }

    return (
      <div className="main-layout">
        <div className='main-header'>
          <MainHeader />
        </div>
        <div className='main-body'>
          <SitePage></SitePage>
        </div>
        <ModalAccountConfig></ModalAccountConfig>
        <ModalAccountForm></ModalAccountForm>
        <ModalConfirm></ModalConfirm>
			  <ModalTip></ModalTip>
        <ModalAlert></ModalAlert>
        <ModalLoading></ModalLoading>
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authToken: state.loginReducers.authToken,
        loginStatus: state.loginReducers.status,
    }
}

export default connect(
  mapStateToProps,
  { doLogout, doActivePage, reLoginBySession }
)(SiteLayout)